// extracted by mini-css-extract-plugin
export default {"label":"BreadcrumbLabel_label__EAWkC","active":"BreadcrumbLabel_active__FA6Y9","noEllipsis":"BreadcrumbLabel_noEllipsis__AKDV+"};